import { Module } from '@nestjs/common';
import { CompraAsistidaService } from './compra-asistida.service';
import { CompraAsistidaController } from './compra-asistida.controller';
import { PrismaModule } from 'src/prisma/prisma.module';
import { BancardModule } from 'src/bancard/bancard.module';

@Module({
  imports: [PrismaModule, BancardModule],
  controllers: [CompraAsistidaController],
  providers: [CompraAsistidaService],
})
export class CompraAsistidaModule {}
